import Vue from 'vue'
import Vuex from 'vuex'
import security from './modules/security.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    security,
  }
})
